import { Typography } from "@mui/material";

import {
  faqs,
  howItWorks,
  InventoryCard,
  SuitesContent,
  LegendsContent,
  AnalyticsHeader,
  studioSuiteNames,
  legendSuiteNames,
  StudioSuiteContent,
  createPerkTotalLabel,
  LeftFieldPorchContent,
  purchaseSeatsLanguages,
  inventoryCardSuiteModal,
  redeemGiftCardLanguages,
  leftFieldPorchSuiteNames,
  purchaseGiftCardLanguages,
} from "./helpers";
import { routes } from "@/global/routes";
import {
  DbacksTCLanguage,
  DbacksHamburgerTCListItems,
  DbacksAdditionalDetailsDisclaimerTC,
} from "../../tc_helper_dbacks";
import { createJsxLink } from "@/global/utils/utils.dom";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

import suiteImage3 from "public/images/diamondbacks/image.png";
import foodImage1 from "public/images/diamondbacks/dbacks_food1.jpg";
import BackgroundImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import PremiumMenu from "public/images/diamondbacks/D-backs Suite Menu.jpg";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";

const porchImage1 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%201.JPG";
const porchImage2 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%202.JPG";
const porchImage3 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%203.jpg";
const porchImage4 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%204.JPG";
const RFHRPorchMenu =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/RF%20HR%20Porch.png";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png";
const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/MK05-10251389%20Web%20-%202026%20Attend%20Site%20Specs-1486x148_SPECIAL%20EVENT%20SUITES.jpg";

const LeftFieldPorchImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/20240413_CardinalsvsDbacks_kg192%20(2).jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9370-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9375-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9385-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/LF%20HR%20Porch%20Menu.png",
];

const LegendSuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Legends/20250408_LegendsSuites_kg003.JPG",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Legends/20250806_BannerHealthTrophy_mu006.JPG",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Legends/DSC_9150.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Legends/DSC_9160.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Legends/Legends%20Menu.png",
];

const RandySuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8690-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8710-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/Premium%20Menu%202026%20Screenshot.png",
];

const suite20Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8955-Edit-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8960-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Premium%20Menu%202026%20Screenshot.png",
];

const suite23Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8560-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8890.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Premium%20Menu.png",
];

const config: TeamConfig = {
  teamSchema: "dbacks_specialeventsuites",
  browserTitle: "Arizona Diamondbacks",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 109,
  teamName: "Arizona Diamondbacks",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10167-diamondbacks-sec",
    mapId: "blockmap2d",

    suiteSectionNameMapping: {
      "Studio@122A": ["Studio A"],
      "Studio@122B": ["Studio B"],
      "Legends Suite C": ["Legends C"],
      "Legends Suite D": ["Legends D"],
      "Legends Suite E": ["Legends E"],
      "Legends Suite F": ["Legends F"],
    },

    isShowAvailableSeatsButtonHidden: true,
    dvmFallback3dViewSectionId: "S_144",

    suiteImages: [
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%201.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%202.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%203.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%204.jpg",
      PremiumMenu.src,
    ],

    specificSectionImages: {
      PRCHL1: LeftFieldPorchImages,
      PRCHL2: LeftFieldPorchImages,
      PRCHL3: LeftFieldPorchImages,
      PRCHL4: LeftFieldPorchImages,
      PRCHL5: LeftFieldPorchImages,
      PRCHL6: LeftFieldPorchImages,
      PRCHL7: LeftFieldPorchImages,
      PRCHL8: LeftFieldPorchImages,

      PRCHR1: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR2: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR3: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR4: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR5: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR6: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR7: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR8: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR9: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],

      122: [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC_9225-Edit.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC_9230.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC04331.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/Studio@122%20Menu.png",
      ],

      S10: RandySuiteImages,
      S1: RandySuiteImages,
      S2: RandySuiteImages,
      S3: RandySuiteImages,
      S4: RandySuiteImages,
      S5: RandySuiteImages,
      S6: RandySuiteImages,
      S7: RandySuiteImages,
      S8: RandySuiteImages,
      S9: RandySuiteImages,
      S11: RandySuiteImages,
      S12: RandySuiteImages,
      S13: RandySuiteImages,
      S14: RandySuiteImages,
      S15: RandySuiteImages,
      S50: RandySuiteImages,
      S51: RandySuiteImages,
      S52: RandySuiteImages,
      S53: RandySuiteImages,
      S55: RandySuiteImages,

      S16: suite20Images,
      S17: suite20Images,
      S18: suite20Images,
      S19: suite20Images,
      S20: suite20Images,
      S21: suite20Images,

      S22: suite23Images,
      S23: suite23Images,
      S24: suite23Images,
      S25: suite23Images,
      S28: suite23Images,
      S29: suite23Images,
      S30: suite23Images,
      S31: suite23Images,
      S32: suite23Images,
      S33: suite23Images,
      S34: suite23Images,
      S35: suite23Images,
      S36: suite23Images,
      S37: suite23Images,
      S38: suite23Images,
      S39: suite23Images,
      S40: suite23Images,
      S41: suite23Images,
      S44: suite23Images,
      S45: suite23Images,
      S46: suite23Images,
      S47: suite23Images,
      S48: suite23Images,
      S49: suite23Images,

      TheDraftRoom: LegendSuiteImages,
    },

    specificEventCodeSectionImages: {
      "26DB506": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-01260068%20Group%20Promo%20Item%20Mocks%20-%20Round%202_Nurse%203-4%20Sleeve.png",
      ],
      "26DB519": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Golf%20Spring%202%20copy.png",
      ],
      "26DB522": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/ST35-02260209%20Group%20Promo%20Item%20Mocks%20-%20Round%204-Military%20Hat%20update.png",
      ],
      "26DB603": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Japan%20copy.png",
      ],
      "26DB605": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Pride%20copy.png",
      ],
      "26DB606": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-01260068%20Group%20Promo%20Item%20Mocks%20-%20Round%202_Filipino%20Heritage%20Jersey.png",
      ],
      "26DB822": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_PR%20copy.png",
      ],
      "26DB825": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Heritage%20Hat_Greece%20copy.png",
      ],
      "26DB914": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Heritage%20Hat_Ireland%20copy.png",
      ],
      "26DB915": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Special%20Events%20Suites/TO15-12251754%202026%20Group%20Promo%20Item%20Mocks%20-%20Round%201_Heritage%20Hat_Germany%20copy.png",
      ],
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    invPreviewAccountGroup: ["0"],
    isPerksEnabled: true,
    isCheckoutAdditionalDetailsEnabled: true,
    hideViewTicketsInThankYouPage: true,

    allowCheckoutFromPreview: true,
  },

  oktaClientId: "",
  oktaIssuer: "",
  platform: vendorUUIDs.ticketmaster,
  refreshInventoryWhenEventClick: false,

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    AnalyticsHeader: AnalyticsHeader,
  },

  isSaveCardAllowed: true,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/azdbacks/my-events",

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage,
    findGamesBannerImage: BannerImage,
    authBackgroundImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    checkoutStatusPageImage: BackgroundImage.src,
    logoImage: LogoImage + "?width=84&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    inventoryContainer: {
      emptyStateTitle: "No D-backs Suites Available.",
      emptyStateDesc: (
        <>
          Try another game or email{" "}
          {createJsxLink("suites@dbacks.com", "mailto:suites@dbacks.com")} for
          suite availability to this game
        </>
      ),
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 190),
    },

    inventoryCardSettings: {
      isPBLineItemsVisible: false,
      isParkingPriceVisible: true,
      seatCountLabel: "Tickets Included",

      suiteLevelInventoryCard: {
        customButtons: [
          {
            id: 1,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LeftFieldPorchContent />,
              });
            },
            suiteNames: leftFieldPorchSuiteNames,
          },
          {
            id: 2,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <StudioSuiteContent />,
              });
            },
            suiteNames: studioSuiteNames,
          },
          {
            id: 3,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <SuitesContent />,
              });
            },
            suiteNames: Array.from({ length: 57 }, (_, i) => `Suite ${i + 1}`), // Suites 1 to 57
          },
          {
            id: 4,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LegendsContent />,
              });
            },
            suiteNames: legendSuiteNames,
          },
        ],
        renderBody: [
          {
            id: 1,
            component: () => <InventoryCard />,
          },
        ],
      },
    },

    perks: {
      hideAddAllButton: true,
      images: {
        foodUpgrade: [foodImage1.src],
        handsHistory: [suiteImage3.src],
      },
      displayOnlyPrice: ["handsHistory", "foodUpgrade"],
      isOpenByDefault: true,
    },
    checkoutPerkSubtotals: {
      perkTotalLabel: createPerkTotalLabel,
    },

    eventCardSettings: {
      noInventoryMessage: "Email suites@dbacks.com for availability.",
      hideSoldOutTag: true,
    },

    checkoutPage: {
      checkoutForm: {
        hideContractTitle: true,
        hideContractLastName: true,
        hideContractFirstName: true,
        hideContractAddress: false,
        sameAsContractSignerDefaultChecked: true,
        optionalAdditionalDetailsContractTitle: true,
        optionalAdditionalDetailsContractLastName: true,
        optionalAdditionalDetailsContractFirstName: true,
      },
    },

    findGames: {
      setEventsWithoutSorting: true,
    },
  },

  colors: {
    primary: "#AA182C",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <DbacksHamburgerTCListItems />, // can be react node as well
    checkoutTermsAndCondition: <DbacksTCLanguage />,
    registrationTermsAndCondition: <DbacksTCLanguage />,
    additionalDetailsDisclaimerTC: <DbacksAdditionalDetailsDisclaimerTC />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,

    checkoutServiceNote: (
      <Typography variant="body2" color="textSecondary">
        Your reservation is not yet complete until notification from the Arizona
        Diamondbacks confirming your reservation has been accepted in accordance
        with our agreement.
      </Typography>
    ),

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
